import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { DirtyComponent } from 'src/app/component/dirty/dirty.component';
import { CommonService } from 'src/app/services/common/common.service';
import { SessionAddSuccessDialogComponent } from '../session-add-success-dialog/session-add-success-dialog.component';
import { AddNewSessionLabelConstant } from 'src/app/constants/LabelConstants';
import { AddNewSessionErrorMessage } from 'src/app/constants/ErrorMessages';

@Component({
    selector: 'app-add-new-session-dialog',
    templateUrl: './add-new-session-dialog.component.html',
    styleUrls: ['./add-new-session-dialog.component.scss'],
    standalone: false
})
export class AddNewSessionDialogComponent implements OnInit {

  // Common Properties
  addSessionForm: FormGroup;
  submitted: boolean = false;
  customerId: any;
  customerData: any = [];
  passData: any;
  LabelConstant: any;
  ErrorMessage: any;

  constructor(
    private dialogRef: MatDialogRef<AddNewSessionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private api: ApiUrlHelper,
    private commonService: CommonService,
    private fb: FormBuilder,
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.addSessionForm = this.fb.group({
      AdminReply: ['', Validators.required]
    })
    if (this.customerId > 0) {
      this.fetchCustomerDetails();
    }
    this.LabelConstant = AddNewSessionLabelConstant;
    this.ErrorMessage = AddNewSessionErrorMessage;
  }

  get addSessionFormControls() {
    return this.addSessionForm.controls;
  }

  cancel() {
    if (this.addSessionForm.dirty) {
      const dialogRef = this.dialog.open(DirtyComponent, {
        width: '500px',
        data: {
          action: 'Customer',
        },
        disableClose: true,
        autoFocus: false
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          this.dialogRef.close();
        }
      });
    } else {
      this.dialogRef.close();
    }
  }

  submitAddSesionForm() {
    this.submitted = true;
    if (this.addSessionForm.valid) {
      let obj = {
        OrderDetailId: this.passData.orderDetailId,
        OrderId: this.passData.orderId,
        CustomerId: this.customerId,
        SessionId: this.passData.model[0].classSessionId,
        UserId: 0,
        PaymentPassId: this.passData.paymentPassId,
        ReplyMessageByAdmin: this.addSessionForm.value.AdminReply?.trim()
      }
      this.spinner.show();
      let api = this.api.apiUrl.Report.AddExtraSession;
      this.commonService.doPost(api, obj).pipe().subscribe({
        next: (response) => {
          if (response.success) {
            this.spinner.hide();
            const dialogRef = this.dialog.open(SessionAddSuccessDialogComponent, {
              width: '700px',
              data: {
              },
              disableClose: true,
              autoFocus: false
            });
            dialogRef.componentInstance.customerData = this.customerData;
            dialogRef.afterClosed().subscribe((result) => {
              this.dialogRef.close();
            });

          } else {
            this.spinner.hide();
            this.toastr.error(response.message);
          }
        },
        error(err) {
          this.spinner.hide();
          console.log(err);
        },
      });
    }
  }

  fetchCustomerDetails() {
    this.spinner.show();
    let api = this.api.apiUrl.Customer.GetCustomerById.replace('{Id}', this.customerId);
    this.spinner.show();
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.customerData = response.data;
          this.spinner.hide();
        }
        else {
          this.spinner.hide();
        }
      },
      error(err) {
        this.spinner.hide();
        console.log(err);
      },
    });
  }

  handleImageError() {
    this.customerData.images = '../../../../assets/img/default-customer-profile.svg';
  }
}
